package es.cragma.fichajefacil

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlin.js.ExperimentalWasmJsInterop

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    ComposeViewport {
        App(
            onGoogleSignInRequested = { onSuccess ->
                signInWithGoogle { email ->
                    onSuccess(email)
                }
            },
            onAppleSignInRequested = { onSuccess ->
                signInWithApple { email ->
                    onSuccess(email)
                }
            }
        )
    }
}

@OptIn(ExperimentalWasmJsInterop::class)
@JsFun("(onSuccess) => { if (window.signInWithGoogle) window.signInWithGoogle(onSuccess); }")
external fun signInWithGoogle(onSuccess: (String) -> Unit)

@OptIn(ExperimentalWasmJsInterop::class)
@JsFun("(onSuccess) => { if (window.signInWithApple) window.signInWithApple(onSuccess); }")
external fun signInWithApple(onSuccess: (String) -> Unit)
